import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_DELETE_POST_MUTATION = gql`
  mutation Post(
    $slugName: String!,
    ) {
    postDeletePost(
      slugName: $slugName,
      ) {
      isAuth
      isDeleted
      slugName
    }
  }
`;

const postDeletePost = async ({
  id,
  slugName,
}) => {
  try {
    const result = await client.mutate({
      mutation: POST_DELETE_POST_MUTATION,
      variables: {
        id,
        slugName,
      },
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { postDeletePost: postDeletePostValidationData } } = result;

    if (postDeletePostValidationData) {
      return postDeletePostValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postDeletePostValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postDeletePost Error: ${error}`);
    return null;
  }
};

export default postDeletePost;
